import globalAxios from "../../../util/Api";
import { GET_SYSTEM_SETTING, EDIT_SYSTEM_SETTING, START_LOADING, ERROR, STOP_LOADING, DATA_DECLERATION_PDF } from "./types";
import { LogoutAction } from "../../../actions";
import numeral from 'numeral';
import 'numeral/locales/de'

export const GetSystem = (otherTab) => {
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().get(`/api/v1/systems`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_SYSTEM_SETTING, payload: res.data.data })
          if (otherTab !== "project")
            dispatch(GetSystemPdf())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const GetSystemPdf = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/systems/1/datadeclaration`)
      .then(res => {
        const binaryString = atob(res.data.data_base64);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < len; i += 1) {
          view[i] = binaryString.charCodeAt(i);
        }
        const blob = new File([view], { type: 'application/pdf' });
        const href = window.URL.createObjectURL(blob);
        if (res) {
          dispatch({ type: DATA_DECLERATION_PDF, payload: href })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}

export const EditSystem = (id, registering, plaining, hoursperday, vatrate, selectedFile) => {
  numeral.locale('de');
  let bodyFormData = new FormData();
  bodyFormData.append('system[hoursperday]', numeral(hoursperday).value());
  bodyFormData.append('system[toleranceplaning]', numeral(plaining).value());
  bodyFormData.append('system[toleranceregistering]', numeral(registering).value());
  bodyFormData.append('system[vatrate]', numeral(vatrate).value());
  if (selectedFile)
    bodyFormData.append('system[datadeclaration]', selectedFile);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/systems/${id}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: EDIT_SYSTEM_SETTING, payload: res.data.data })
          dispatch(GetSystemPdf())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.data })
      })
  }
}
